import { getMiddleCenterBias } from '@glideapps/glide-data-grid';

import type { DrawHeaderCallback } from '@glideapps/glide-data-grid';

import type { Lang } from '../types';

import { COLUMN_IDS } from '../constants';

const dateColIndex = COLUMN_IDS.indexOf('date');

type Args = Parameters<DrawHeaderCallback>[0];

const getUserReadableDateFormat = (lang: Lang) => {
  switch (lang) {
    case 'en-GB':
      return 'DD/MM/YYYY';
    case 'en-US':
      return 'MM/DD/YYYY';
    case 'en-CA':
      return 'YYYY/MM/DD';
    default:
      return 'DD/MM/YYYY';
  }
};

export const drawHeaderCells = (
  { ctx, theme, rect, isHovered, columnIndex, column }: Args,
  lang: Lang
) => {
  if (columnIndex < 0) return;

  const x = rect.x + theme.cellHorizontalPadding;
  const y = rect.y + rect.height / 2 + getMiddleCenterBias(ctx, theme as any);

  ctx.fillStyle = isHovered ? theme.bgHeaderHovered : theme.bgHeader;
  ctx.fillRect(rect.x, rect.y, rect.width, rect.height);

  // Custom paint for the date column header
  if (columnIndex === dateColIndex) {
    ctx.fillStyle = theme.textMedium;
    ctx.fillText(column.title, x, y - 9);

    ctx.fillStyle = theme.textLight;
    ctx.fillText(getUserReadableDateFormat(lang), x + 33, y - 9);

    ctx.font = `12px ${theme.fontFamily}`;
    ctx.fillStyle = theme.accentColor;
    ctx.fillText('Change format', x, y + 9);

    ctx.beginPath();
    ctx.strokeStyle = theme.accentColor;
    ctx.lineWidth = 1;
    ctx.moveTo(x, y + 15);
    ctx.lineTo(x + 80, y + 15);
    ctx.stroke();

    return;
  }

  ctx.fillStyle = theme.textMedium;
  ctx.fillText(column.title, x, y);
};
